import { render, staticRenderFns } from "./VehicleItem.vue?vue&type=template&id=39147170&scoped=true"
import script from "./VehicleItem.vue?vue&type=script&lang=js"
export * from "./VehicleItem.vue?vue&type=script&lang=js"
import style0 from "./VehicleItem.vue?vue&type=style&index=0&id=39147170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39147170",
  null
  
)

export default component.exports